export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13091.26cd6ad8.jpg";